<app-layout-one-column *ngIf="hasError" header="We encountered a problem activating your invitation.">
  <h1>We encountered a problem activating your invitation.</h1><br><br>
  <p>We at the AMA are always making our website better for physicians, residents and medical students.</p>
  <hr>
  <h2>Need help signing in?</h2>
  <p>Contact the <a href="https://www.ama-assn.org/eform/submit/contact-us">AMA Unified Service Center</a> online or call (800) 621-8335 for assistance.</p>
</app-layout-one-column>
